import { equal, integer, min } from 'vue-mc/validation';
import { BaseModel } from './BaseModel';

export default class KitchenOrder extends BaseModel {
  // Default attributes that define the "empty" state.
  defaults() {
    return {
      id: null,
      status: null,
      number: null,
      kitchenReadyTime: null,
      facilityReadyTime: null,

      // Totals
      subtotal: 0,
      discount_total: 0,
      reimbursable_discount_total: 0,
      discount_tax_total: 0,
      tax_total: 0,
      tip_total: 0,
      order_total: 0,

      // Commission / fee totals
      zuul_commission: 0,
      facility_commission: 0,
      partner_commission: 0,
      employer_commission: 0,
      processing_fee: 0,
      delivery_charge: 0,
      fee_total: 0,
      net_total: 0,

      // Relationships
      fulfillment_center_id: 0,
      fulfillment_center: {},
      fulfillment_center_order_refunds: [],
      fulfillment_center_order_coupons: [],
      network_order_id: 0,
      network_order: {},
      orderItems: [],
    };
  }

  options() {
    return {
      identifier: 'id',
    };
  }

  // Attribute validation
  validation() {
    return {
      id: integer.and(min(1)).or(equal(null)),
    };
  }

  // Route configuration
  routes() {
    const includes = [
      'networkOrder',
      'fulfillmentCenter',
      'fulfillmentCenterOrderRefunds.networkOrderRefund',
      'fulfillmentCenterOrderCoupons.orderCoupon',
      'orderItems',
      'networkOrder.facility',
      'networkOrder.delivery',
      'networkOrder.network',
      'networkOrder.address',
      'networkOrder.user',
    ];
    const appends = ['kitchenReadyTime', 'facilityReadyTime'];

    return {
      fetch: `/fulfillment-center-orders/{id}?with=${includes.join(
        ','
      )}&appends=${appends.join(',')}`,
      save: `/fulfillment-center-orders/{id}?with=${includes.join(',')}`,
    };
  }

  // Override onFetchSuccess
  onFetchSuccess(response) {
    const me = this;
    const data = response.getData();

    if (!data || !data.success) {
      throw me.createResponseError('Invalid record');
    }

    me.assign(data.data);
    me.set(me, 'fatal', false);
    me.set(me, 'loading', false);
    me.emit('fetch', {
      error: null,
    });
  }
}
